export default "__VITE_ASSET__CNjnHrNV__"